"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareNatural = compareNatural;
exports.sortByNaturalTitle = sortByNaturalTitle;
/**
 * Collator configured for "natural" ordering.
 *
 * `numeric: true` makes runs of digits compare by numeric value instead of
 * character by character, so "1.2.2" < "1.2.10" and "9. Scrogging" < "10. Foo".
 * Plain string comparison (and Firestore/lexicographic ordering) would put
 * "1.2.10" before "1.2.2" because "1" < "2" as a character.
 *
 * `sensitivity: "base"` ignores case and accents, so "storage" and "Storage"
 * are treated as equal.
 */
var naturalCollator = new Intl.Collator("en", { numeric: true, sensitivity: "base" });
/**
 * Compares two optional strings using natural ordering.
 * Missing values are treated as empty strings and therefore sort first.
 *
 * Returns a negative number if `a` sorts before `b`, positive if after, 0 if equal.
 * Suitable for passing directly to `Array.prototype.sort`.
 */
function compareNatural(a, b) {
    return naturalCollator.compare(a !== null && a !== void 0 ? a : "", b !== null && b !== void 0 ? b : "");
}
/**
 * Returns a new array of `items` sorted by natural order of the string
 * produced by `getTitle`.
 *
 * The input array is not mutated: RTK Query responses are frozen, and an
 * in-place `.sort()` on them would throw.
 *
 * Example:
 *   sortByNaturalTitle(sops, (sop) => sop.title)
 *   // "1.2.0 Clone", "1.2.1 Veg", "1.2.10 Late Veg", "1.3.1 Flip", "3. Storage", "4.1 Goods"
 */
function sortByNaturalTitle(items, getTitle) {
    return __spreadArray([], items, true).sort(function (a, b) { return compareNatural(getTitle(a), getTitle(b)); });
}
